import { render, staticRenderFns } from "./iconHeart.vue?vue&type=template&id=47332c50"
import script from "./iconHeart.vue?vue&type=script&lang=js"
export * from "./iconHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports